import axios from 'services/http';
import { CancelTokenSource } from 'axios';
import { ProcedureStatisticRequest } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/procedure-statistic`;

export const exportProcedureStatistic = (request: Partial<ProcedureStatisticRequest>,
                                                 source: CancelTokenSource) => {
  return axios
      .post(`${apiUri}/export`, request, {cancelToken: source.token})
      .then(response => {
        const type = response.headers['content-type'];
        // @ts-ignore
        const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = response.headers['content-disposition'];
        const filenameRegex = /filename=(.*)/;
        const regexResponse = filenameRegex.exec(link.download);
        const defaultFileName = "response.csv";
        const fileName = regexResponse ?
            regexResponse[1] ? regexResponse[1] : defaultFileName :
            defaultFileName;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click()
      })
};
